import AccordionCustom from './AccordionCustom'

export function PageCategories(props) {
  return (
    <AccordionCustom
      isPrivate={props.isPrivate}
      section={props.section}
      categories={props.categories}
      searchText={props.searchText}
      preExpanded={props.preExpanded}
      isChild={false}
      showMovetocategory={true}
    />
  )
}
